import axios from 'axios'
import { configure } from 'axios-hooks'
import LRU from 'lru-cache'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import moment from 'moment'
import { I18n } from 'react-polyglot'
import * as Sentry from '@sentry/browser'
import ReduxToastr from 'react-redux-toastr'

import getPhrases from 'lang'
import App from 'views/app'

import { initAuth } from 'features/auth'

import history from 'configureHistory'
import configureStore from './store'

const store = configureStore()
const rootElement = document.getElementById('root')

if (process.env.NODE_ENV === 'production') {
	Sentry.init({
		dsn: 'https://c89ef860d4a44feb82f6370517431d40@sentry.ueberlab.com/5',
	})
}

// F. ex. http://localhost:3000/?app=desktop&platform=darwin
if (new URL(window.location.href).searchParams.get('app') === 'desktop') {
	document.body.classList.add('u-desktop-app')

	if (
		new URL(window.location.href).searchParams.get('platform') === 'darwin'
	) {
		document.body.classList.add('u-desktop-app--darwin')
	}
}

axios.interceptors.request.use(config => {
	config.baseURL = `${process.env.API}/`

	return config
})

axios.interceptors.response.use(
	response => {
		return response
	},
	error => {
		const res = error.response

		if (res?.config && !res.config.__isRetryRequest) {
			return new Promise((resolve, reject) => {
				if (
					error?.response?.status === 401 &&
					error?.response?.data?.message === 'Invalid credentials'
				) {
					window.location.reload()
				}

				error.config.__isRetryRequest = true

				reject(error)
			})
		}

		return Promise.reject(error)
	}
)

const cache = new LRU({ max: 10 })

configure({ axios, cache })

let locale
const userLanguage = navigator.language || navigator.userLanguage

if (userLanguage.includes('-')) {
	locale = userLanguage.split('-')[0]
} else {
	locale = userLanguage
}

if (getPhrases()[locale]) {
	moment.updateLocale(locale, getPhrases()[locale].relative_time)
}

function render(Component) {
	// if (process.env.DT && process.env.DT.length) {
	// 	console.log(
	// 		`Last update: ${moment
	// 			.tz(
	// 				moment.utc(
	// 					moment(process.env.DT, 'YYYY-MM-DD-HH:mm:ss').format(
	// 						'Y-MM-DD HH:mm:ss'
	// 					)
	// 				),
	// 				'Europe/Berlin'
	// 			)
	// 			.format('DD.MM.YYYY HH:mm:ss')}`
	// 	)
	// }

	ReactDOM.render(
		<I18n
			locale={locale}
			messages={getPhrases()[locale] || getPhrases().en}
			options={{
				allowMissing: true, // A boolean to control whether missing keys are allowed
				onMissingKey: key => alert(key),
			}}

			// /** If allow missing is true this function will be called instead of default error handler **/
			// onMissingKey?: (key: string, options?: InterpolationOptions, locale?: string) => string;

			// /** An object to change the substituation syntax for interpolation by setting prefix and suffix **/
			// interpolation?: InterpolationTokenOptions;

			// /** https://github.com/airbnb/polyglot.js#custom-pluralization-rules */
			// pluralRules?: PluralRules;
		>
			<Provider store={store}>
				<ConnectedRouter history={history}>
					<Component />
				</ConnectedRouter>

				<ReduxToastr
					timeOut={8000}
					progressBar
					newestOnTop
					position="bottom-right"
					transitionIn="fadeIn"
					transitionOut="fadeOut"
					// preventDuplicates
				/>
			</Provider>
		</I18n>,
		rootElement
	)
}

initAuth(store.dispatch, store.getState).then(() => render(App))

if (module.hot) {
	module.hot.accept('views/app', () => {
		render(require('views/app').default)
	})
}
